module.exports = __webpack_public_path__ + "img/diagnosis-plans.947759c4.svg";